
export const ar = {
  // App Name & Branding
  appName: 'موف برو',
  appNameEn: 'MovePro',
  tagline: 'خدمات النقل الذكي',
  
  // Navigation
  home: 'الرئيسية',
  orders: 'طلباتي',
  newTrip: 'رحلة جديدة',
  notifications: 'الإشعارات',
  profile: 'حسابي',
  back: 'رجوع',
  
  // Authentication
  welcome: 'مرحباً بك',
  welcomeMessage: 'سجل دخولك للاستمتاع بخدمات النقل الذكي',
  phoneNumber: 'رقم الجوال',
  email: 'البريد الإلكتروني',
  password: 'كلمة المرور',
  confirmPassword: 'تأكيد كلمة المرور',
  fullName: 'الاسم الكامل',
  city: 'المدينة',
  login: 'تسجيل الدخول',
  register: 'إنشاء حساب',
  guestMode: 'الدخول كضيف',
  forgotPassword: 'نسيت كلمة المرور؟',
  dontHaveAccount: 'ليس لديك حساب؟',
  alreadyHaveAccount: 'لديك حساب بالفعل؟',
  createAccount: 'إنشاء حساب جديد',
  startUsing: 'ابدأ الاستخدام',
  
  // Home Page
  currentLocation: 'موقعك الحالي',
  howToTravel: 'كيف تريد السفر؟',
  regularRide: 'طلب عادي',
  regularRideDesc: 'سعر ثابت بناءً على المسافة',
  specialRide: 'طلب خاص',
  specialRideDesc: 'نظام المزايدة للحصول على أفضل سعر',
  exclusiveOffers: 'العروض الحصرية',
  quickDestinations: 'وجهات سريعة',
  recentActivity: 'النشاط الأخير',
  viewAll: 'عرض الكل',
  reorder: 'إعادة الطلب',
  
  // Booking
  newBooking: 'حجز رحلة جديدة',
  pickupLocation: 'موقع الاستلام',
  destination: 'الوجهة',
  enterDestination: 'أدخل الوجهة',
  vehicleType: 'نوع المركبة',
  economy: 'اقتصادي',
  family: 'عائلي',
  vip: 'VIP',
  estimatedPrice: 'السعر المتوقع',
  confirmRequest: 'تأكيد الطلب',
  biddingRequest: 'طلب مزايدة',
  
  // Booking Confirmation
  confirmBooking: 'تأكيد الحجز',
  tripDetails: 'تفاصيل الرحلة',
  from: 'من',
  to: 'إلى',
  vehicleTypeLabel: 'نوع المركبة',
  estimatedDistance: 'المسافة المتوقعة',
  estimatedTime: 'الوقت المتوقع',
  price: 'السعر',
  paymentMethod: 'طريقة الدفع',
  cash: 'نقداً',
  mada: 'مدى',
  visa: 'فيزا',
  confirmAndSearch: 'تأكيد الحجز والبحث عن سائق',
  termsMessage: 'بالمتابعة، أنت توافق على شروط وأحكام الخدمة وسياسة الخصوصية',
  
  // Trip Tracking
  searching: 'جاري البحث',
  searchingMessage: 'جاري البحث عن أقرب سائق متاح...',
  driverFound: 'تم العثور على سائق',
  driverFoundMessage: 'تم العثور على سائق! جاري التوجيه...',
  tripTracking: 'تتبع الرحلة',
  driverInfo: 'معلومات السائق',
  callDriver: 'اتصال بالسائق',
  messageDriver: 'مراسلة السائق',
  tripStatus: 'حالة الرحلة',
  requestAccepted: 'تم قبول الطلب',
  driverOnWay: 'السائق في الطريق',
  inProgress: 'جاري التنفيذ',
  completed: 'تم الوصول',
  
  // Payment
  payment: 'الدفع',
  finalPrice: 'السعر النهائي',
  selectedPayment: 'طريقة الدفع المختارة',
  discounts: 'الخصومات',
  payNow: 'ادفع الآن',
  paymentSuccess: 'تم الدفع بنجاح',
  rateTrip: 'قيم الرحلة',
  rateDriver: 'قيم السائق',
  addComment: 'أضف تعليق',
  submitRating: 'إرسال التقييم',
  thankYou: 'شكراً لك',
  
  // Orders
  currentOrders: 'الطلبات الحالية',
  completedOrders: 'الطلبات المكتملة',
  cancelledOrders: 'الطلبات الملغاة',
  orderDetails: 'تفاصيل الطلب',
  date: 'التاريخ',
  status: 'الحالة',
  viewDetails: 'عرض التفاصيل',
  call: 'اتصال',
  message: 'رسالة',
  
  // Profile
  userInfo: 'معلومات المستخدم',
  editProfile: 'تعديل حسابي',
  tripHistory: 'سجل الرحلات',
  savedPayments: 'طرق الدفع المحفوظة',
  settings: 'الإعدادات',
  language: 'اللغة',
  darkMode: 'الوضع الليلي',
  notificationsSettings: 'إعدادات الإشعارات',
  logout: 'تسجيل الخروج',
  totalTrips: 'إجمالي الرحلات',
  totalSpent: 'إجمالي المبلغ المنفق',
  averageRating: 'متوسط التقييم',
  
  // Notifications
  notificationsList: 'قائمة الإشعارات',
  requestAcceptedNotif: 'تم قبول طلبك',
  driverOnWayNotif: 'السائق في الطريق',
  paymentReceivedNotif: 'تم استلام المبلغ',
  
  // Common
  save: 'حفظ',
  cancel: 'إلغاء',
  confirm: 'تأكيد',
  edit: 'تعديل',
  delete: 'حذف',
  search: 'بحث',
  filter: 'تصفية',
  sort: 'ترتيب',
  loading: 'جاري التحميل...',
  error: 'حدث خطأ',
  success: 'تم بنجاح',
  retry: 'إعادة المحاولة',
  
  // Status
  pending: 'في الانتظار',
  accepted: 'مقبول',
  onWay: 'في الطريق',
  arrived: 'وصل',
  inProgress: 'جاري التنفيذ',
  completed: 'مكتمل',
  cancelled: 'ملغي',
  
  // Quick Destinations
  airport: 'المطار',
  hospital: 'المستشفى',
  shopping: 'التسوق',
  university: 'الجامعة',
  
  // Messages
  sendMessage: 'إرسال رسالة',
  typeMessage: 'اكتب رسالتك هنا...',
  send: 'إرسال',
  messageSent: 'تم إرسال الرسالة',
  
  // Bidding
  biddingMode: 'نظام المزايدة',
  waitingOffers: 'انتظار العروض',
  receivedOffers: 'العروض المستلمة',
  driverName: 'اسم السائق',
  carType: 'نوع السيارة',
  suggestedPrice: 'السعر المقترح',
  rating: 'التقييم',
  selectOffer: 'اختيار العرض',
  
  // Error Messages
  enterDestinationError: 'يرجى إدخال الوجهة',
  connectionError: 'خطأ في الاتصال',
  locationError: 'خطأ في تحديد الموقع',
  
  // Success Messages
  bookingConfirmed: 'تم تأكيد الحجز',
  driverAssigned: 'تم تعيين السائق',
  tripCompleted: 'تم إكمال الرحلة',
  
  // Promo Codes
  promoCode: 'كود الخصم',
  enterPromoCode: 'أدخل كود الخصم',
  applyPromo: 'تطبيق الكود',
  promoApplied: 'تم تطبيق الكود',
  invalidPromo: 'كود خصم غير صالح'
};

export default ar;
